// Copyright (c) 2016 Deere & Company

import OpenPartRequests from '../../part-requests/open-parts-requests/state-connector';

export default {
    component: OpenPartRequests,
    name: 'OPEN_PART_REQUESTS',
    path: 'open'
};



// WEBPACK FOOTER //
// ./src/routes/part-requests/open-part-requests.js